import { render, staticRenderFns } from "./SideBar.vue?vue&type=template&id=1cdc2624&scoped=true"
import script from "./SideBar.vue?vue&type=script&lang=js"
export * from "./SideBar.vue?vue&type=script&lang=js"
import style0 from "../assets/scss/sidebar.scss?vue&type=style&index=0&id=1cdc2624&prod&lang=scss&scoped=true&external"
import style1 from "./SideBar.vue?vue&type=style&index=1&id=1cdc2624&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1cdc2624",
  null
  
)

export default component.exports